import { lazy, Suspense, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, Route, Switch } from "react-router-dom";
import { useGlobalContext } from "../../context/globalContext";
import Steps from "../../shared/steps/steps";
import Loader from "../../shared/loaders/simpleLoader";
import { SERVICE_TYPES } from "../../utils/constants/fieldErrors";
import useServiceType from "../../hooks/useServiseType";
import { useContactInfoChangeStepsContext } from "../../context/ContactInfoChangeContext";

const Agreement = lazy(() =>
  import("../../components/ContactInfoChangeForm/steps/agreement")
);
const Step2 = lazy(() =>
  import("../../components/ContactInfoChangeForm/steps/step2")
);
const Step3 = lazy(() =>
  import("../../components/ContactInfoChangeForm/steps/step3")
);
const Step4 = lazy(() =>
  import("../../components/ContactInfoChangeForm/steps/step4")
);

export function ContactInfoChangeStepRoutes() {
  const { steps, activeStep, setActiveStep } =
    useContactInfoChangeStepsContext();
  const { i18n } = useTranslation();
  const { serviceType } = useServiceType();

  const {
    globalData: { status },
  } = useGlobalContext();
  const isApproved = useMemo(() => status !== "Approved", [status]);

  return (
    <Steps
      steps={steps}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      hideSteps={serviceType !== SERVICE_TYPES.ContactInfoChangeForm && true}
    >
      <Suspense fallback={<Loader />}>
        {isApproved ? (
          <Switch>
            <Route
              component={Agreement}
              path={`/ContactInfoChange/agreement/:mobile?/${i18n.language}`}
            />
            <Route
              component={Step2}
              path={`/ContactInfoChange/Identomat/${i18n.language}`}
            />
            <Redirect to={`/ContactInfoChange/agreement/${i18n.language}`} />
          </Switch>
        ) : (
          <Switch>
            <Route component={Step3} path={`/ContactInfoChange/step/3`} />
            <Route component={Step4} path={`/ContactInfoChange/step/4`} />
            <Redirect to={`/ContactInfoChange/step/3`} />
          </Switch>
        )}
      </Suspense>
    </Steps>
  );
}
